import React, { useState } from 'react';

import { Button } from 'reactstrap';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import Modal from '../../../common/modal/Modal';

import TicketCorporateCreditUnifyInvoicesForm from './TicketCorporateCreditUnifyInvoicesForm';
import { putTicketCorporateInvoices } from '../../../../actions/corporate/TicketCorporateCredit';

const TicketCorporateCreditUnifyInvoicesButton = ({
  ticketCorporateCreditId,
  dispatchPutTicketCorporateInvoices,
  companyId,
}) => {
  const [showModal, setShowModal] = useState(false);

  const onSubmit = ({ ticketIds }) => {
    dispatchPutTicketCorporateInvoices({
      ticketIds,
      ticketCorporateCreditId,
    });
  };

  const body = (
    <TicketCorporateCreditUnifyInvoicesForm
      onSubmit={onSubmit}
      companyId={companyId}
    />
  );

  const openModal = () => {
    setShowModal(true);
  };

  const closeModal = () => {
    setShowModal(false);
  };

  return (
    <>
      <Button color="success" onClick={openModal}>
        <i className="fa fa-files-o" /> Unificar boletos
      </Button>

      <Modal
        show={showModal}
        title="Unificar tickets"
        body={body}
        onClickClose={closeModal}
      />
    </>
  );
};

TicketCorporateCreditUnifyInvoicesButton.propTypes = {
  ticketCorporateCreditId: PropTypes.number.isRequired,
  dispatchPutTicketCorporateInvoices: PropTypes.func.isRequired,
  companyId: PropTypes.number.isRequired,
};

const mapDispatchToProps = {
  dispatchPutTicketCorporateInvoices: putTicketCorporateInvoices,
};

export default connect(
  null,
  mapDispatchToProps,
)(TicketCorporateCreditUnifyInvoicesButton);
